import actions from './actions'
import mutations from './mutations'

const getDefaultState = () => {
  return {
    showPromotionBanner: null,
    lastFetchDate: null
  }
}

const state = getDefaultState()

mutations.RESET_STATE = state => {
  Object.assign(state, getDefaultState())
}
actions.reset = ({ commit }) => {
  commit('RESET_STATE')
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/banner/index.js